module.exports = __webpack_public_path__ + "static/media/HIW_hero.1c1409f3.jpg";